import * as angular from "angular";
import {IController} from "angular";
import {AnalyticsService} from "../../modules/commons/services/analytics-service.service";

export class WelcomeMainViewComponent implements IController {

  public isLoaded: boolean = false;
  public selectedSkin:any;

  constructor(private IAMPermissions, private UserService, private intercom, private analyticsService: AnalyticsService,private triSkins) {
  }

  $onInit() {
    this.selectedSkin = this.triSkins.getCurrent();

    this.IAMPermissions.setSuperPermissions()
      .then((permissions) => {
        const user = this.UserService.getCurrentUser();
        this.intercom.update(user, 'Welcome Page', permissions);
        this.analyticsService.initWelcome(user, permissions);
      })
      .finally(() => {
        this.isLoaded = true;
      })
  }

}

angular
  .module('bringoz.admin.commons')
  .component('welcomeMainView', {
    bindings: {},
    template: require('./welcome-main-view.html').default,
    controller: WelcomeMainViewComponent
  });
